export const breakpoints = {
  values: {
    xs: 0,
    sm: 536,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
}
